import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "mandae-condicao-faixa-cep",
  templateUrl: "./faixa-cep.component.html",
  styleUrls: ["./faixa-cep.component.scss"],
})
export class CondicaoFaixaCepComponent {
  public formulario: FormGroup;

  public restricaoCeps = [];

  public mensagem = "";

  public erro = false;

  @Input()
  public set Data(data) {
    if (data) {
      this.restricaoCeps = data;
    }
  }

  @Input()
  public label = "Faixa de CEP";

  @Input()
  public fieldName = "faixasCep";

  @Output()
  public condicaoResponse = new EventEmitter();

  constructor(private formBuilder: FormBuilder) {
    this.formulario = this.formBuilder.group({
      inicial: [null, Validators.required],
      final: [null, Validators.required],
    });
  }

  public formData(value) {
    return this.formulario.get(value).value;
  }

  public adicionarFaixa(): void {
    const inicial = this.formulario.get("inicial").value;
    const final = this.formulario.get("final").value;

    this.formulario.get("inicial").setErrors(null);
    this.formulario.get("final").setErrors(null);
    this.formulario.get("inicial").markAsUntouched();
    this.formulario.get("final").markAsUntouched();
    this.erro = false;

    const restricao = {
      valorInicial: inicial,
      valorFinal: final,
    };

    if (inicial && final) {
      if (inicial.length === 8 && final.length === 8) {
        if (inicial !== final && inicial < final) {
          this.restricaoCeps.push(restricao);
          this.apagarCampos();

          this.condicaoResponse.emit({
            tipo: this.fieldName,
            valor: this.restricaoCeps,
          });
        } else {
          this.erro = true;

          // nao tem valor o cep inicial e final
          if (!inicial && !final) {
            this.formulario.get("inicial").setErrors({ incorrect: true });
            this.formulario.get("inicial").markAsTouched();
            this.formulario.get("final").setErrors({ incorrect: true });
            this.formulario.get("final").markAsTouched();
            this.mensagem =
              "O CEP inicial e o CEP final precisam ser preenchidos";

            return;
          }

          // nao tem valor o cep inicial
          if (!inicial) {
            this.formulario.get("inicial").setErrors({ incorrect: true });
            this.formulario.get("inicial").markAsTouched();
            this.mensagem = "O CEP inicial precisa ser preenchido";
            return;
          }

          // nao tem valor o cep final
          if (!final) {
            this.formulario.get("final").setErrors({ incorrect: true });
            this.formulario.get("final").markAsTouched();
            this.mensagem = "O CEP final precisa ser preenchido";
            return;
          }

          if (inicial === final) {
            this.formulario.get("inicial").setErrors({ incorrect: true });
            this.formulario.get("inicial").markAsTouched();
            this.formulario.get("final").setErrors({ incorrect: true });
            this.formulario.get("final").markAsTouched();

            this.mensagem = "O valor inicial é igual ao final.";
            return;
          }

          if (inicial > final) {
            this.formulario.get("inicial").setErrors({ incorrect: true });
            this.formulario.get("inicial").markAsTouched();

            this.mensagem = "O CEP inicial é maior que o CEP final.";
            return;
          }
        }
      } else {
        this.erro = true;

        if (inicial.length < 8) {
          this.formulario.get("inicial").setErrors({ incorrect: true });
          this.formulario.get("inicial").markAsTouched();

          this.mensagem = "O CEP precisa ter 8 digitos";

          return;
        }

        if (final.length < 8) {
          this.formulario.get("final").setErrors({ incorrect: true });
          this.formulario.get("final").markAsTouched();

          this.mensagem = "O CEP precisa ter 8 digitos";
          return;
        }
      }
    } else {
      if (!inicial) {
        this.formulario.get("inicial").setErrors({ incorrect: true });
        this.formulario.get("inicial").markAsTouched();
      }

      if (!final) {
        this.formulario.get("final").setErrors({ incorrect: true });
        this.formulario.get("final").markAsTouched();
      }
    }
  }

  public removerFaixa(faixa: Range): void {
    const index = this.restricaoCeps.indexOf(faixa);

    if (index >= 0) {
      this.restricaoCeps.splice(index, 1);

      this.condicaoResponse.emit({
        tipo: this.fieldName,
        valor: this.restricaoCeps,
      });
    }
  }

  public apagarCampos() {
    this.formulario.get("inicial").setValue("");
    this.formulario.get("final").setValue("");

    this.formulario.get("inicial").markAsUntouched();
    this.formulario.get("final").markAsUntouched();
  }
}
